export class AddCreditCardError extends Error {
  modalAppearanceEventMessage: string;

  constructor(message: string, modalAppearanceEventMessage: string) {
    super(message);
    this.modalAppearanceEventMessage = modalAppearanceEventMessage;
  }
}
